import { ROUTE_PIPELINES } from 'js/constants/pathnames';
import RoutePrefixContext from 'new/contexts/RoutePrefixContext';
import { Button } from 'new/elements/support/Button';
import React from 'react';
import { withRouter } from 'react-router-dom';

class ViewEntityPipelineButton extends React.Component {
  static contextType = RoutePrefixContext;

  constructor(props) {
    super(props);

    this._handleViewPipelineClicked = this._handleViewPipelineClicked.bind(this);
  }

  render() {
    if (!this.props.filterType) return null;

    const commonProps = {
      variant: 'contained',
      className: 'view-entity-pipeline-button view-entity-button ' + this.props.className,
      onClick: this._handleViewPipelineClicked,
    };

    const title = this.props.title || 'View Data Flow';

    if (this.props.ButtonComponent) {
      return React.cloneElement(this.props.ButtonComponent, {
        onClick: this._handleViewPipelineClicked,
      });
    }

    return (
      <Button {...commonProps} className={this.props.className}>
        {title}
      </Button>
    );
  }

  _handleViewPipelineClicked() {
    const { filterType, filterValue, history } = this.props;

    // navigate to pipelines
    history.push(`${this.context}${ROUTE_PIPELINES}?search=${filterType}:${filterValue}`);
  }
}

export default withRouter(ViewEntityPipelineButton);
